import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { ArcadeBox, Flex, spacing, Text } from '@cash-design-system/react'
import { FormBlockerEditorialContentElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { useTextTokenizer } from '@cash-web/shared-feature-use-text-tokenizer'
import { replaceWithCDNImageUrl } from '@cash-web/shared-util-url'

const HeroImage = styled.img`
  width: 100%;
  height: 10rem;
  object-fit: cover;
  border-radius: inherit;
`

const FlexContainer = styled(Flex)<{ hasImage: boolean }>`
  padding: ${({ hasImage }) => (hasImage ? spacing.l : spacing.m)} ${spacing.m} ${spacing.m};
`

export const EditorialContentElement = ({
  title_text,
  detail_text,
  hero_image,
}: FormBlockerEditorialContentElement) => {
  const { darkMode } = useTheme()
  const textTokenizer = useTextTokenizer()

  const rawUrl = darkMode ? hero_image?.dark_url : hero_image?.light_url
  const imageUrl = rawUrl ? replaceWithCDNImageUrl({ url: rawUrl }) : undefined

  return (
    <ArcadeBox backgroundColor="backgroundSubtle" borderRadius="medium" padding="s">
      <Flex flexDirection="column">
        {imageUrl && <HeroImage src={imageUrl} alt={title_text ?? ''} />}
        <FlexContainer flexDirection="column" gap={spacing.m} hasImage={!!imageUrl}>
          {title_text && (
            <Text typography="headlineSmall" color="textStandard">
              {title_text}
            </Text>
          )}
          {detail_text && (
            <Text typography="bodyMedium" color="textStandard">
              {textTokenizer(detail_text)}
            </Text>
          )}
        </FlexContainer>
      </Flex>
    </ArcadeBox>
  )
}
